module.exports = __webpack_public_path__ + "static/media/marker_temporary_bus_stop_orange_hover.9e8fbe7e.svg";